import { Fade } from 'react-reveal';
import styled from 'styled-components';
import PodcastCard from './PodcastCard';


function Podcast() {
    
    
  return (
    <Container className='container'>
        <Fade up>
        <h2 className='text-center'>Listen to Our Podcast</h2>
        </Fade>

        <div className="podcast-container">
                <PodcastCard/>
                <PodcastCard/>
                <PodcastCard/>

        </div>

    </Container>
  )
}

export default Podcast
const Container = styled.div` 
    .podcast-container{
        display:grid ;
        grid-gap:10px ;
        grid-template-columns:repeat(auto-fit,minmax(300px,1fr)) ;
    }
    text-align:left ;
    h1{
        color:#fa7525 ;
    }

margin-top:50px ;

 #podcast-list{
     display: flex;
 }
`
